import { TSummary } from "../../utils/DTO/SummaryDTO";

export const isPrevention = (summary: TSummary) => {
  return summary?.painArea === "prevention";
};
